export default function CentresApi({ makeRequest, buildRequest }) {

    function getCentres() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Centres'));
        });
    }

    function getCentresSummary() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Centres/Summary'));
        });
    }

    function getCentresLookupList() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Centres/LookupList'));
        });
    }

    function getCentresDetailed() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Centres/Detailed'));
        });
    }

    function getCentreById(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Centres/${centreId}`));
        });
    }

    function getCentreDetailed(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Centres/Detailed/${centreId}`));
        });
    }

    function upsertCentre(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Centres/Upsert', payload));
        });
    }

    function upsertCentreDetailed(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Centres/UpsertDetailed', payload));
        });
    }

    function deleteCentre(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Centres/${centreId}`));
        });
    }

    return {
        getCentres,
        getCentresSummary,
        getCentresLookupList,
        getCentresDetailed,
        getCentreById,
        getCentreDetailed,
        upsertCentre,
        upsertCentreDetailed,
        deleteCentre,
    };
}
